import React, { useState } from 'react';
import { connect } from 'react-redux';

import {
        Chart as ChartJS,
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        BarElement,
        Title,
        Tooltip,
        Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import RptNoData from './RptNoData';
import RptSingleTotalPDF from './RptSingleTotalPDF';
import { PDFDownloadLink } from '@react-pdf/renderer';
import RptSingleTotalXLS from './RptSingleTotalXLS';
import Menu from '../../Menu';



import { formatCurrency } from '../../functions';

ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        BarElement,
        Title,
        Tooltip,
        Legend
);

const dataTotal = (data) => {
	return data.reduce((a, b) => {
		return a + b.dollars
	}, 0);
};

const dataTotalQty = (data) => {
	return data.reduce((a, b) => {
		return a + b.qty
	}, 0);
};

// let dollarUSLocale = Intl.NumberFormat('en-US');

const mapStateToProps = (state) => {
	return {		
        lastWeekColor: state.lastWeekColor,
        thisWeekColor: state.thisWeekColor
	}
}

function RptSingleTotal(props){
	const [chart64,setChart64] = useState();
    const [showThemeSelector, setShowThemeSelector] = useState(false);

	const pdfChart = () => {
		
		let chartDiv = document.getElementById('pdfChart');
		if(chartDiv){
			
			let base64img = chartDiv.getElementsByTagName('canvas')[0].toDataURL();
			
			setChart64(base64img);
		}		
	}

	if(!props.data){
		return (
			<RptNoData />
		);
	}

	if(props.data.length > 0){
		

		let bar_labels = props.data.map((record) => record.description);

		let bar_data = {
            labels: bar_labels,
            datasets: [
                {
                    label: 'Amount',
                    data: props.data.map((record) => record.dollars.toFixed(2)),
							borderColor: props.thisWeekColor,
							backgroundColor: `${props.thisWeekColor}`
                },
                {
					hidden: true,
                    label: 'Qty',
                    data: props.data.map((record) => record.qty.toFixed(0)),
                    borderColor: 'rgb(87, 138, 200)',
                    backgroundColor: 'rgba(87, 138, 200, 0.5)',
                }
            ],
		};

		let  bar_options = {
			indexAxis: 'y',
			scales: {
				y: {
					ticks: {
						autoSkip: false
					}
				}
			},			
			elements: {
                bar: {
                    borderWidth: 2,
                },
			},
			responsive: true,
			maintainAspectRatio: false,
			plugins: {
				legend: {
					display: false,
					position: 'bottom',
					labels: {
							usePointStyle: true,
							pointStyle: 'rect',
					},
				},
				title: {
					display: true,
					text: [props.title],
					font: {
							size: 18,
					}
				},
				tooltip: {
					callbacks: {
						label: (tooltipItem, chart) => {
							return bar_data.datasets.map(ds => ds.label + ': ' + ds.data[tooltipItem.dataIndex]);
						}
					}
				},
			}
		};

		let bar_height = props.data.length * 30 + 150;

		let  pdfbar_options = {
			indexAxis: 'y',
			scales: {
				y: {
					ticks: {
						autoSkip: false
					}
				}
			},
			elements: {
					bar: {
							borderWidth: 2,
					},
			},
			animation: {
				duration: 0,
				onComplete: function () {
					pdfChart();
				}
			},
			responsive: true,
			maintainAspectRatio: false,
			plugins: {
				legend: {
					display: false,
					position: 'bottom',
					labels: {
							usePointStyle: true,
							pointStyle: 'rect',
							font: {
								size: 6
							}
					},
				},
				title: {
					display: true,
					text: [props.title],
					font: {
							size: 18,
					}
				}
			}
		};

		let pdfbar_height = props.data.length * 30 + 150;
		if(pdfbar_height > 700) { pdfbar_height = 700; }

		return (
			<div id='ReportData' className='d-flex flex-column'>
                <div id='pdfChart' style={{position:'absolute',left:'-9999px',top:'-9999px', width:'500px',height:pdfbar_height}}>
                    <Bar options={pdfbar_options} data={bar_data} />
                </div>			
				<div className='d-flex justify-content-start theme-secondary pt-2 pb-2 ps-2'>
                    <PDFDownloadLink fileName={props.title+'.pdf'} document={<RptSingleTotalPDF data={props.data} chart={chart64} />}>
                        {({ blob, url, loading, error }) => (loading ? null : <button className='btn btn-secondary p-1'><i className="icon bi bi-filetype-pdf fa-2xl"></i></button>)}
                    </PDFDownloadLink>
                    <RptSingleTotalXLS filename={props.title+'.xlsx'} data={props.data} />
				</div>


				<div style={{height: bar_height+'px'}}>
                    <Bar options={bar_options} data={bar_data} />
                </div>
				<div className='d-flex justify-content-center fw-bold mb-3'>
                    Total: ${formatCurrency(dataTotal(props.data).toFixed(2))}
                </div>
				<div className='d-flex flex-row'>
					<div className='col-sm-3 d-none d-sm-flex m-0 p-1'>&nbsp;</div>
					<div className='col-6 col-sm-5 d-flex m-0 p-1'><b>{ props.description ? props.description : 'Description' }</b></div>
					<div className='col-3 col-sm-2 d-flex m-0 p-1'><b>Qty</b></div>
					<div className='col-3 col-sm-2 d-flex text-left m-0 p-1'><b>Amt</b></div>
				</div>
				<hr className='m-1 p-0' />
                {
                    props.data.map((record,index) => (
                        <div key={index} className='d-flex flex-row'>
                            <div className='col-sm-3 d-none d-sm-flex m-0 p-1'>{record.code}</div>
                            <div className='col-6 col-sm-5 d-flex m-0 p-1' data-ltitle={record.description}>
                                <span className='d-block text-truncate'>{record.description}</span>
                            </div>
                            <div className='col-3 col-sm-2 d-flex m-0 p-1'>
                                {record.qty.toFixed(0) !== 0 ? record.qty.toFixed(0) : null}
                            </div>
                            <div className='col-3 col-sm-2 d-flex text-left m-0 p-1' data-rtitle={formatCurrency(record.dollars.toFixed(2))}>
                                <span className='d-block value-field'>
                                    {record.dollars.toFixed(2) !== 0.00 ? `$${formatCurrency(record.dollars.toFixed(2))}` : "$0.00"}
                                </span>
                            </div>
                        </div>
                    ))
                }
                <hr className='m-1 p-0' />
                <div className='d-flex flex-row'>
                    <div className='col-6 col-sm-8 d-flex fw-bold m-0 p-1'>Total</div>
                    <div className='col-3 col-sm-2 d-flex fw-bold m-0 p-1'>
                        {dataTotalQty(props.data).toFixed(0)}
                    </div>
                    <div className='col-3 col-sm-2 d-flex text-left fw-bold m-0 p-1'>
                        ${formatCurrency(dataTotal(props.data).toFixed(2))}
                    </div>
                </div>

			</div>
		);
	}
	else{
		return (
			<RptNoData />
		);
	}
}

export default connect(
    mapStateToProps
)(RptSingleTotal);

